import React, { Component } from 'react';
import '../css/basics/Button.css';

/*
button--primary
color
- primary
- secondary
- navy
- green
- yellow
- salmon
- red
- orange
- aqua
- blue
- blue-core
*/

class Button extends Component {
  constructor(props) {
    super(props);
    this.class = 'button';
  }

  render() {
    this.class = 'button';
    if (this.props.disabled) {
      this.class = this.class + ' button--disabled';
    }else {
      this.class = this.class + (this.props.color ? ' button--' + this.props.color: '');
    } 

    this.class = this.props.short ? this.class + ' button--short' : this.class;
    if (this.props.className) {
      this.class = this.class + ' ' + this.props.className;
    }

    return (
      this.props.id ? 
      (<button id={this.props.id} onClick={this.props.onClick} className={this.class} disabled={this.props.disabled}>
        {this.props.children}
      </button>) : 
      (<button onClick={this.props.onClick} className={this.class} disabled={this.props.disabled}>
        {this.props.children}
      </button>)
    );
  }
}

export default Button;
